module.exports = __webpack_public_path__ + "img/512.3704c635.png";